import { useState } from 'react';
import { OptimizedImage } from '@components/optimized-image';

import { MagicSearchItemMediaProps } from '../magic-search-palette.type';

// Twice the 36px tile, so covers stay sharp on high-density screens.
const MEDIA_SIZE = 72;

export const MagicSearchItemMedia = ({ Icon, imageUrl }: MagicSearchItemMediaProps) => {
  const [hasImageFailed, setHasImageFailed] = useState(false);

  if (imageUrl && !hasImageFailed) {
    return (
      <OptimizedImage
        src={imageUrl}
        alt=''
        width={MEDIA_SIZE}
        height={MEDIA_SIZE}
        fit='cover'
        loading='lazy'
        onError={() => setHasImageFailed(true)}
        className='h-9 w-9 shrink-0 rounded-md bg-tertiary object-cover'
        dataTestid='magic-search-item--cover'
      />
    );
  }

  return (
    <span className='flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-tertiary text-secondary'>
      <Icon className='h-4.5 w-4.5 fill-current' aria-hidden />
    </span>
  );
};
